import { Currencies } from "@finway-group/shared/lib/consts"
import { CurrencyEnum, currencyEnumArray } from "@finway-group/shared/lib/models"
import { Form, Image, Select } from "antd"
import { Rule } from "antd/lib/form"
import React from "react"
import { useTranslation } from "react-i18next"
import { doFilterSelect, getCurrencyFlag } from "~Shared/utils/helper.utils"
import { getPopupAnchor } from "~Shared/utils/popup.utils"

interface CurrencySelectProps {
    onCurrencyChange?: (data: any) => void
    initialValue?: CurrencyEnum | null
    name?: string | Array<string | number>
    label?: string
    required?: boolean
    rules?: Array<Rule>
    key?: string
    customCurrencyEnumArray?: Array<CurrencyEnum>
    extra?: string
    size?: "small" | "large"
    disabled?: boolean
    anchor?: HTMLElement | null
}

export const CurrencySelect = ({
    onCurrencyChange = () => {},
    initialValue = CurrencyEnum.EUR,
    name = "currency",
    label,
    required = false,
    rules,
    key = "currency",
    customCurrencyEnumArray = currencyEnumArray,
    extra,
    size = "large",
    disabled = false,
    anchor,
}: CurrencySelectProps) => {
    const { t } = useTranslation()
    const itemLabel = label ?? t("input:request.currency")

    return (
        <Form.Item name={name} label={itemLabel} key={key} initialValue={!initialValue ? undefined : initialValue} required={required} rules={rules} extra={extra}>
            <Select
                showSearch
                filterOption={doFilterSelect}
                getPopupContainer={anchor ? getPopupAnchor(anchor) : getPopupAnchor()}
                onChange={(v) => onCurrencyChange({ currency: v })}
                disabled={disabled}
            >
                {customCurrencyEnumArray.map((currencyValue, index) => (
                    <Select.Option key={index} value={currencyValue} label={currencyValue}>
                        <div className="space-x-10 flex items-center">
                            <div className="flex-shrink-0 flex items-center">
                                <Image width={20} preview={false} src={getCurrencyFlag(currencyValue)} />
                            </div>
                            <span className="text-text">
                                {currencyValue} {size === "large" && ` - ${Currencies[currencyValue].name}`}
                            </span>
                        </div>
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    )
}
